import { render, staticRenderFns } from "./PerformanceQueryDetail.vue?vue&type=template&id=36a27444&scoped=true"
import script from "./PerformanceQueryDetail.vue?vue&type=script&lang=js"
export * from "./PerformanceQueryDetail.vue?vue&type=script&lang=js"
import style0 from "./PerformanceQueryDetail.vue?vue&type=style&index=0&id=36a27444&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a27444",
  null
  
)

export default component.exports